import React, { useState } from 'react';
import './FAQ.css';

const faqData = [
  {
    question: 'Jak mogę umówić się na konsultację?',
    answer: 'Wystarczy wypełnić formularz kontaktowy lub zadzwonić bezpośrednio do studia.',
  },
  {
    question: 'Czy mogę poprosić o indywidualny projekt?',
    answer: 'Tak, każdy projekt jest tworzony na indywidualne zamówienie klienta.',
  },
  {
    question: 'Jak długo trwa realizacja projektu?',
    answer: 'Czas realizacji zależy od zakresu prac, ale zazwyczaj wynosi od 2 do 6 tygodni.',
  },
];

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleIndex = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="faq-container">
      <h2>Najczęstsze zapytania od klientów</h2>
      {faqData.map((item, index) => (
        <div
          key={index}
          className={`faq-item ${activeIndex === index ? 'active' : ''}`}
        >
          <button className="faq-question" onClick={() => toggleIndex(index)}>
            {item.question}
            <span className="arrow" />
          </button>
          <div className="faq-answer-wrapper">
            <div className="faq-answer">{item.answer}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;
